import React, { useEffect } from 'react';
import Slider from '@material-ui/core/Slider';
import { useSelector, useDispatch } from 'react-redux';
import { pushValueString, pushSelectedChipArray } from '../../slices/RiskFilterSlice';
import { StyledBody } from './StyledTypeComponent';

function valuetext(value) {
  return `${value}`;
}

export default function RangeSlider() {
  const [value, setValue] = React.useState([0, 100]);
  const filterQueryArray = useSelector(state => state.riskFilterSlice.filterQueryArray);
  const dispatch = useDispatch();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    let scoreString = value[0] + ' to ' + value[1];
    dispatch(pushValueString(scoreString));
    let chipArray = [];
    chipArray.push(filterQueryArray[0] + ' ' + filterQueryArray[1] + ' ' + scoreString);
    dispatch(pushSelectedChipArray(chipArray));
  }, [value]);
  const marks = [{
    value: 0,
    label: '0'
  }, {
    value: 100,
    label: '100'
  }];
  return /*#__PURE__*/React.createElement(StyledBody, null, /*#__PURE__*/React.createElement(Slider, {
    value: value,
    onChange: handleChange,
    valueLabelDisplay: "auto",
    "aria-labelledby": "range-slider",
    getAriaValueText: valuetext,
    marks: marks
  }));
}